var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1577_3314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1577_3314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7921 26.0402C21.4979 26.0402 18.6778 24.8672 16.3319 22.5213C13.986 20.1754 12.813 17.3553 12.813 14.0611C12.813 10.7669 13.986 7.94678 16.3319 5.60088C18.6778 3.25498 21.4979 2.08203 24.7921 2.08203C28.0864 2.08203 30.9064 3.25498 33.2523 5.60088C35.5982 7.94678 36.7712 10.7669 36.7712 14.0611C36.7712 17.3553 35.5982 20.1754 33.2523 22.5213C30.9064 24.8672 28.0864 26.0402 24.7921 26.0402ZM0.833984 57.4983V41.6129C0.833984 39.9159 1.27072 38.3561 2.14419 36.9336C3.01767 35.5111 4.17814 34.4255 5.62561 33.6768C8.7202 32.1295 11.8647 30.969 15.0591 30.1954C18.2535 29.4218 21.4979 29.0349 24.7921 29.0349C28.0864 29.0349 31.3307 29.4218 34.5251 30.1954C37.7195 30.969 40.864 32.1295 43.9586 33.6768C45.4061 34.4255 46.5666 35.5111 47.44 36.9336C48.3135 38.3561 48.7502 39.9159 48.7502 41.6129V57.4983H0.833984Z",
    fill: "url(#paint0_linear_1577_3314)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1577_3314",
    x1: 28.4561,
    y1: -5.62549,
    x2: 28.4561,
    y2: 117.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7733F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515226,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3954cfae706ecb4e4c7bb52ad46f83ae.svg";
export { ForwardRef as ReactComponent };